<template>
  <div>
    <p>
      🤩 מעוניינים להגיש מועמדות? 🤩
      <br>
      להגשת מועמדות >> {{position_link}}
      <br>
      <br>
      ⭐ להגשת מועמדות באמצעות המייל: שלחו אלינו (בציון מספר משרה {{ $utils.getPositionApplicantCode(position.id) }}) את קורות החיים שלכם וספרו לנו בשפה חופשית על עצמכם ועל התאמתכם למשרה – כדאי לפרט ולהרחיב!
      <br>
      המייל שלנו: hr@suitup.co.il
      <br>
      <br>
      ⭐ לצפייה במשרות חמות בעולם האדמיניסטרציה והכספים: https://suitup.co.il/office_positions
      <br>
      <br>
      ⭐ מומלץ לעקוב אחרינו 👍 בעמוד הפייסבוק שלנו לקבלת עדכונים חמים, תכנים מקצועיים וטיפים לחיפוש עבודה:
      <br>
      משרות פייננס - https://www.facebook.com/suitupFinance
      <br>
      משרות אופיס - https://www.facebook.com/suitupHR
      <br>
      משרות ליגל - https://www.facebook.com/suitup.co.il
    </p>
  </div>
</template>
<script>
export default {
  name: 'office-footer',
  props: ['position', 'position_link']
}
</script>
